import { formatDistanceToNow } from 'date-fns';

/**
 * Like date-fns formatDistanceToNow, but tolerant of server/client clock skew.
 * If the timestamp is in the future relative to the browser (or within a 60s
 * future buffer), we display "just now" instead of "in 3 months".
 */
export function timeAgo(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return '';
  const now = Date.now();
  // Anything in the future, or less than 30s old → "just now"
  if (d.getTime() > now - 30 * 1000) {
    return 'just now';
  }
  return formatDistanceToNow(d, { addSuffix: true });
}
